import { render, staticRenderFns } from "./PermissionRow.vue?vue&type=template&id=23266e41"
import script from "./PermissionRow.vue?vue&type=script&lang=js"
export * from "./PermissionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23266e41')) {
      api.createRecord('23266e41', component.options)
    } else {
      api.reload('23266e41', component.options)
    }
    module.hot.accept("./PermissionRow.vue?vue&type=template&id=23266e41", function () {
      api.rerender('23266e41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/PermissionRow.vue"
export default component.exports